const panel = {
  root: {
    marginBottom: '{spacing.xxs}',
    background: '{white}',
    borderRadius: '{borderRadius.l}',
  },
  header: {
    borderWidth: '0px',
    marginBottom: '{spacing.ss}',
  },
  icon: {
    container: {
      marginRight: '{spacing.s}',
      fontSize: '{sizes.l}',
    },
  },
  default: {
    shadow: '0 0 6px 0 rgba(0,0,0,.2)',
    padding: '{spacing.ml}',
  },
  sub: {
    borderRadius: '{borderRadius.s}',
    padding: '{spacing.m}',
    borderWidth: '1px',
    backgroundColor: 'rgba(226,230,236,.75)',
    borderColor: '{gray.scale.300}',
  },
  bare: {
    shadow: '0 0 6px 0 rgba(0,0,0,.2)',
    borderRadius: '{borderRadius.m}',
    backgroundColor: '{white}',
  },
  colorScheme: {
    light: {
      root: {
        info: {
          backgroundColor: '{primary.background.color}',
          borderColor: '{primary.color}',
          labelColor: '{primary.color}',
        },
        success: {
          backgroundColor: '{secondary.background.color}',
          borderColor: '{secondary.color}',
          labelColor: '{secondary.color}',
        },
        warning: {
          backgroundColor: '{warning.background.color}',
          borderColor: '{warning.color}',
          labelColor: '{warning.color}',
        },
        danger: {
          backgroundColor: '{error.background.color}',
          borderColor: '{error.color}',
          labelColor: '{error.color}',
        },
      },
    },
  },
};

export default panel;
// # sourceMappingURL=index.mjs.map
